module.exports = __webpack_public_path__ + "img/lock.b926cd76.png";